import ApiInfo from './ApiInfo.js';

class SalesApiInfo extends ApiInfo {
  // 声明接口类
  constructor({
    path,
    type = 'get',
    timeout = 30000,
    headers,
    project = 'sales-crm',
    author = '未定义',
  }) {
    super({
      path,
      type,
      timeout,
      headers,
      project,
      author,
    });
  }
}

export default {
  common: {
    // 通用config
    config: new SalesApiInfo({
      path: '/common/config',
      type: 'get',
      author: '唐猛',
    }),
    // 行业信息
    category: new SalesApiInfo({
      path: '/common/category/list',
      type: 'get',
      author: '唐猛',
    }),
    // 上传接口
    uploadFile: new SalesApiInfo({
      path: '/common/upload/file',
      type: 'post',
      author: '唐猛',
    }),
    // 组织架构
    structure: new SalesApiInfo({
      path: '/common/structure',
      type: 'get',
      author: '唐猛',
    }),
    // 字典
    dict: new SalesApiInfo({
      path: '/common/dict',
      type: 'get',
      author: '唐猛',
    }),
    dictname: new SalesApiInfo({
      path: '/common/dict-name',
      type: 'get',
      author: '唐猛',
    }),
    // 添加字典
    dictAdd: new SalesApiInfo({
      path: '/common/dict/add',
      type: 'post',
      author: '唐猛',
    }),
    // 删除字典
    dictDelete: new SalesApiInfo({
      path: '/common/dict/delete',
      type: 'post',
      author: '唐猛',
    }),
    // 编辑字典
    dictEdit: new SalesApiInfo({
      path: '/common/dict/edit',
      type: 'post',
      author: '唐猛',
    }),
  },
  amis: {
    // 获取amis-json
    getPage: new SalesApiInfo({
      path: '/site/info',
      type: 'get',
      author: '徐从斌',
    }),
    // 修改amis-json
    updateJson: new SalesApiInfo({
      path: '/site/upload-json',
      type: 'post',
      author: '徐从斌',
    }),
  },
  user: {
    // 对接鉴权Auth
    syncAuth: new SalesApiInfo({
      path: '/user/user/user-login',
      type: 'post',
      author: '易怀源',
    }),
    // 获取角色列表
    getRoleList: new SalesApiInfo({
      path: '/user/role/list',
      type: 'get',
      author: '唐猛',
    }),
    // 添加角色
    addRole: new SalesApiInfo({
      path: '/user/role/add',
      type: 'post',
      author: '唐猛',
    }),
    // 编辑角色
    editRole: new SalesApiInfo({
      path: '/user/role/audit',
      type: 'post',
      author: '唐猛',
    }),
    // 获取用户列表
    getUserList: new SalesApiInfo({
      path: '/user/user/get-list',
      type: 'get',
      author: '易怀源',
    }),
    // 添加用户
    addUser: new SalesApiInfo({
      path: '/user/user/user-add',
      type: 'post',
      author: '易怀源',
    }),
    // 编辑用户
    editUser: new SalesApiInfo({
      path: '/user/user/user-edit',
      type: 'post',
      author: '易怀源',
    }),
    // 组织架构
    structure: new SalesApiInfo({
      path: '/user/department/get-list',
      type: 'get',
      author: '易怀源',
    }),
    // 获取用户权限
    permissions: new SalesApiInfo({
      // path: '/user/permissions',
      path: '/user/user/get-actions',
      type: 'get',
      author: '唐猛',
    }),
    // 用户转移
    userTransfer: new SalesApiInfo({
      path: '/user/user/user-transfer',
      type: 'post',
      author: '易怀源',
    }),

    // 获取当前用户信息
    userInfo: new SalesApiInfo({
      path: '/user/user/info',
      type: 'post',
      author: '易怀源',
    }),

    userPermList: new SalesApiInfo({
      path: '/user/perm/list',
      type: 'get',
      author: '郭留永',
    }),

    userPermAdd: new SalesApiInfo({
      path: '/user/perm/add',
      type: 'get',
      author: '郭留永',
    }),

    userPermUpdate: new SalesApiInfo({
      path: '/user/perm/edit',
      type: 'post',
      author: '郭留永',
    }),

    userPermRemove: new SalesApiInfo({
      path: '/user/perm/delete',
      type: 'post',
      author: '郭留永',
    }),

    userPermGetRouters: new SalesApiInfo({
      path: '/user/perm/get-routers',
      type: 'post',
      author: '郭留永',
    }),

    userPermAddRouters: new SalesApiInfo({
      path: '/user/router/add',
      type: 'post',
      author: '郭留永',
    }),

    userPermRemoveRouters: new SalesApiInfo({
      path: '/user/router/delete',
      type: 'post',
      author: '郭留永',
    }),

    userRoleList: new SalesApiInfo({
      path: '/user/role/list',
      type: 'get',
      author: '郭留永',
    }),

    userRoleAdd: new SalesApiInfo({
      path: '/user/role/add',
      type: 'get',
      author: '郭留永',
    }),

    userRoleDelete: new SalesApiInfo({
      path: '/user/role/delete',
      type: 'get',
      author: '郭留永',
    }),

    userRoleEdit: new SalesApiInfo({
      path: '/user/role/edit',
      type: 'get',
      author: '郭留永',
    }),

    userRoleAttachPerms: new SalesApiInfo({
      path: '/user/role/attach-perms',
      type: 'get',
      author: '郭留永',
    }),

    userRoleGetPerms: new SalesApiInfo({
      path: '/user/role/get-perms',
      type: 'get',
      author: '郭留永',
    }),

    getControllers: new SalesApiInfo({
      path: '/common/get-controllers',
      type: 'get',
      author: '郭留永',
    }),

    getActions: new SalesApiInfo({
      path: '/common/get-actions',
      type: 'get',
      author: '郭留永',
    }),
  },
  customer: {
    // 创建广告主
    create: new SalesApiInfo({
      path: '/customer/create',
      type: 'post',
      author: '唐猛',
    }),
    // 列表
    list: new SalesApiInfo({
      path: '/customer/private/list',
      type: 'get',
      author: '唐猛',
    }),
    // 详情
    detail: new SalesApiInfo({
      path: '/customer/detail',
      type: 'get',
      author: '唐猛',
    }),
    // 状态更新
    stepStatus: new SalesApiInfo({
      path: '/customer/step/status',
      type: 'post',
      author: '唐猛',
    }),
    // 开户
    infoAdd: new SalesApiInfo({
      path: '/customer/info/add',
      type: 'post',
      author: '唐猛',
    }),
    // 关联账号添加
    addAdvAccount: new SalesApiInfo({
      path: '/customer/account/create',
      type: 'post',
      author: '唐猛',
    }),
    // 关联账号列表
    advAccountList: new SalesApiInfo({
      path: '/customer/account/info',
      type: 'get',
      author: '唐猛',
    }),
    // 修改信息
    infoBaseEdit: new SalesApiInfo({
      path: '/customer/edit',
      type: 'post',
      author: '唐猛',
    }),
    // 修改开户信息
    infoEdit: new SalesApiInfo({
      path: '/customer/info/edit',
      type: 'post',
      author: '唐猛',
    }),
    // 检查是否是大客户？
    isBigCustomer: new SalesApiInfo({
      path: '/customer/bigcustomer',
      type: 'get',
      author: '唐猛',
    }),
    // 获取统计数据
    mydata: new SalesApiInfo({
      path: '/customer/mydata',
      type: 'get',
      author: '唐猛',
    }),
    // 公海列表
    publicList: new SalesApiInfo({
      path: '/customer/public/list',
      type: 'get',
      author: '唐猛',
    }),
    // 导入到私海
    importToPrivate: new SalesApiInfo({
      path: '/customer/private/add',
      type: 'post',
      author: '唐猛',
    }),
    // 释放到公海
    exportToPublic: new SalesApiInfo({
      path: '/customer/public/add',
      type: 'post',
      author: '唐猛',
    }),
    // 广告主列表
    customerList: new SalesApiInfo({
      path: '/customer/list',
      type: 'get',
      author: '唐猛',
    }),
    // 广告主编辑
    customerSaleEdit: new SalesApiInfo({
      path: '/customer/sale/edit',
      type: 'post',
      author: '唐猛',
    }),
    // 广告主下产品
    customerProd: new SalesApiInfo({
      path: '/customer/product',
      type: 'get',
      author: '唐猛',
    }),
    // 报表最新更新日期
    newDate: new SalesApiInfo({
      path: '/data/customer/new-date',
      type: 'get',
      author: '唐猛',
    }),
    // 申请产品列表
    applyProductList: new SalesApiInfo({
      path: '/product/apply/list',
      type: 'get',
      author: '徐从斌',
    }),
    // 新增产品信息
    applyProductAdd: new SalesApiInfo({
      path: '/product/apply/add',
      type: 'post',
      author: '徐从斌',
    }),
    // 更新产品信息
    applyProductUpdate: new SalesApiInfo({
      path: '/product/apply/update',
      type: 'post',
      author: '徐从斌',
    }),

    // 我的客保统计接口
    customerMyStatistics: new SalesApiInfo({
      path: '/customer/my/statistics',
      type: 'post',
      author: '易怀源',
    }),

    // 我的客保接口
    customerMyCustomerProtected: new SalesApiInfo({
      path: '/customer/my/customer-protected',
      type: 'post',
      author: '易怀源',
    }),

    // 我的客户接口
    customerMyCustomerList: new SalesApiInfo({
      path: '/customer/my/customer-list',
      type: 'post',
      author: '易怀源',
    }),

    // 产品报表
    customerMyProductChart: new SalesApiInfo({
      path: '/customer/my/product-chart',
      type: 'post',
      author: '易怀源',
    }),
  },
  // crm新版保产品的接口
  customerStage2: {
    // 通过公司名称查询公司是否已存在接口
    company: new SalesApiInfo({
      path: '/customer/customer/get-by-company',
      type: 'get',
      author: '易怀源',
    }),
    // 创建广告主（客户）
    create: new SalesApiInfo({
      path: '/customer/customer/create-customer',
      type: 'post',
      author: '易怀源',
    }),
    // 修改广告主品牌
    upBrand: new SalesApiInfo({
      path: '/customer/customer/update-customer-brand',
      type: 'post',
      author: '易怀源',
    }),
    // 绑定产品
    bindProduct: new SalesApiInfo({
      path: '/customer/customer/bind-product',
      type: 'post',
      author: '易怀源',
    }),
    // 公海列表
    publicList: new SalesApiInfo({
      path: '/customer/public/list',
      type: 'get',
      author: '易怀源',
    }),
    // 私海列表
    privateList: new SalesApiInfo({
      path: '/customer/private/list',
      type: 'get',
      author: '易怀源',
    }),
    // 广告主详情接口
    detail: new SalesApiInfo({
      path: '/customer/customer/customer-detail',
      type: 'get',
      author: '易怀源',
    }),
    // 查询产品下的开户接口
    productAccount: new SalesApiInfo({
      path: '/customer/account/get-account-by-product',
      type: 'get',
      author: '易怀源',
    }),
    // 广告主相关日志接口
    customerLog: new SalesApiInfo({
      path: '/customer/customer/customer-log',
      type: 'get',
      author: '易怀源',
    }),
    // 私海我的相关数据统计接口
    privateStatics: new SalesApiInfo({
      path: '/customer/private/statistics',
      type: 'get',
      author: '易怀源',
    }),
    // 释放到公海的接口
    exportToPublic: new SalesApiInfo({
      path: '/customer/public/add',
      type: 'post',
      author: '易怀源',
    }),
    // 导入到私海的接口
    importToPrivate: new SalesApiInfo({
      path: '/customer/private/add',
      type: 'post',
      author: '易怀源',
    }),
    // 更新产品进度的接口
    setProductStep: new SalesApiInfo({
      path: '/customer/product/set-product-step',
      type: 'post',
      author: '易怀源',
    }),
    // 开户接口
    createAccount: new SalesApiInfo({
      path: '/customer/account/create-account',
      type: 'post',
      author: '易怀源',
    }),
    // 修改开户接口
    updateAccount: new SalesApiInfo({
      path: '/customer/account/update-account',
      type: 'post',
      author: '易怀源',
    }),
    // 再次开户接口
    addAccount: new SalesApiInfo({
      path: '/customer/account/add-account',
      type: 'post',
      author: '易怀源',
    }),
    // 账户更新进度
    setAccountStatus: new SalesApiInfo({
      path: '/customer/account/set-status',
      type: 'post',
      author: '易怀源',
    }),
    // 查询产品的客户以及销售归属的接口
    productOwner: new SalesApiInfo({
      path: '/product/product-owner',
      type: 'get',
      author: '易怀源',
    }),
    // 归属查询列表
    belong: new SalesApiInfo({
      path: '/product/query-owner',
      type: 'get',
      author: '易怀源',
    }),
  },
  agent: {
    // 列表,代理商管理的列表（老接口，和易怀源定义的新接口冲突了）暂时没有上
    // list: new SalesApiInfo({
    //     path: '/agent/list',
    //     type: 'get',
    //     author: '唐猛'
    // }),
    // 字典
    dictList: new SalesApiInfo({
      path: '/agent/dict/list',
      type: 'get',
      author: '唐猛',
    }),
    // 根据agentId 查询渠道销售
    getChannelSaleByAgentId: new SalesApiInfo({
      path: '/agent/sale/info',
      type: 'get',
      author: '唐猛',
    }),
    // 查询代理商信息的接口
    list: new SalesApiInfo({
      path: '/agent/list',
      type: 'get',
      author: '易怀源',
    }),
    // 产品申请列表-运营
    productAdminList: new SalesApiInfo({
      path: '/product/apply/admin-list',
      type: 'get',
      author: '徐从斌',
    }),
    // 产品申请审核
    productReview: new SalesApiInfo({
      path: '/product/apply/review',
      type: 'post',
      author: '徐从斌',
    }),
  },
  product: {
    list: new SalesApiInfo({
      path: '/product/list',
      type: 'get',
      author: '唐猛',
    }),
    // 产品列表新接口
    productRead: new SalesApiInfo({
      path: '/product/read',
      type: 'get',
      author: '王晓阳',
    }),
    productLog: new SalesApiInfo({
      path: '/product/operate-log',
      type: 'get',
      author: '王晓阳',
    }),
    // 产品列表新接口
    productCategories: new SalesApiInfo({
      path: '/common/category/list',
      type: 'get',
      author: '王晓阳',
    }),
    // 产品列表新接口
    productCheck: new SalesApiInfo({
      path: '/product/check',
      type: 'get',
      author: '王晓阳',
    }),
    // 添加产品
    productAdd: new SalesApiInfo({
      path: '/product/create',
      type: 'post',
      author: '王晓阳',
    }),
    // 编辑产品
    productEdit: new SalesApiInfo({
      path: '/product/update',
      type: 'post',
      author: '王晓阳',
    }),
    // 编辑产品
    productRemarkEdit: new SalesApiInfo({
      path: '/product/update-remark',
      type: 'post',
      author: '王晓阳',
    }),
    // 置为有效无效
    setStatus: new SalesApiInfo({
      path: '/product/set-status',
      type: 'post',
      author: '王晓阳',
    }),
    // 公示查询
    publicNotice: new SalesApiInfo({
      path: '/product/query-owner',
      type: 'get',
      author: '易怀源',
    }),

    queryAdvUser: new SalesApiInfo({
      path: '/product/query-adv-user',
      type: 'get',
      author: '王晓阳',
    }),
    changeOperator: new SalesApiInfo({
      path: '/product/change-operator',
      type: 'post',
      author: '王晓阳',
    }),
  },
  report: {
    // 销售个人卡片数据
    dataCustomerDay: new SalesApiInfo({
      path: '/data/customer/day',
      type: 'get',
      author: '唐猛',
    }),
    // 销售业绩
    dataAchievement: new SalesApiInfo({
      path: '/data/customer/achievement',
      type: 'get',
      author: '唐猛',
    }),
    // 新开户统计
    dataCustomerNew: new SalesApiInfo({
      path: '/data/customer/new',
      type: 'get',
      author: '唐猛',
    }),
    // 媒体
    dataMedia: new SalesApiInfo({
      path: '/data/charge/media',
      type: 'get',
      author: '唐猛',
    }),
    // 停投统计
    stopPut: new SalesApiInfo({
      path: '/data/put/stop',
      type: 'get',
      author: '唐猛',
    }),
    // 渠道组织列表
    channelStructureList: new SalesApiInfo({
      path: '/data/channel-report/channel-sale-list',
      type: 'get',
      author: '杨伟',
    }),
    // 明细列表
    channelList: new SalesApiInfo({
      path: '/data/channel-report/list',
      type: 'post',
      author: '杨伟',
    }),
    // 图表数据
    channelChart: new SalesApiInfo({
      path: '/data/channel-report/chart',
      type: 'post',
      author: '杨伟',
    }),
    venusReportPie: new SalesApiInfo({
      path: '/data/channel-report/pie',
      type: 'post',
      author: '杨伟',
    }),
    // 大盘报表相关接口
    // 查询维度
    queryDimensions: new SalesApiInfo({
      path: '/data/dashboard/dimensions',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    pieData: new SalesApiInfo({
      path: '/data/dashboard/pie',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    lineData: new SalesApiInfo({
      path: '/data/dashboard/line',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    detailData: new SalesApiInfo({
      path: '/data/dashboard/list-detail',
      type: 'post',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    summaryData: new SalesApiInfo({
      path: '/data/dashboard/summary',
      type: 'post',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    summaryDownload: new SalesApiInfo({
      path: '/data/dashboard/summary-download',
      type: 'post',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    detailDownload: new SalesApiInfo({
      path: '/data/dashboard/list-detail-download',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表
    productReportSummary: new SalesApiInfo({
      path: '/data/product-report/summary',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-停投产品
    productReportSummaryStop: new SalesApiInfo({
      path: '/data/product-report/summary-stop-product',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-我的业绩-折线图
    productReportMyPerformance: new SalesApiInfo({
      path: '/data/product-report/my-performance',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    // 聚合报表-我的业绩-折线图
    agentReportMyPerformance: new SalesApiInfo({
      path: '/data/agent-report/chart',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    // 聚合报表-我的业绩-折线图
    directReportMyPerformance: new SalesApiInfo({
      path: '/data/agent-report/direct-chart',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    // ka报表-我的业绩-折线图
    kaReportPerformance: new SalesApiInfo({
      path: '/data/agent-report/ka-summary',
      type: 'post',
      author: '杜伟',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品系报表-我的业绩-折线图
    seriesReportMyPerformance: new SalesApiInfo({
      path: '/data/series-report/chart',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    

    // 产品报表-我的业绩top10-折线图
    productReportTopTen: new SalesApiInfo({
      path: '/data/product-report/top-ten',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 聚合报表-我的业绩top10-折线图
    agentReportTopTen: new SalesApiInfo({
      path: '/data/agent-report/top-ten',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    directReportTopTen: new SalesApiInfo({
      path: '/data/agent-report/direct-top-ten',
      type: 'get',
      author: '杜伟',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // KA报表-我的业绩top20-折线图
    agentReportTop20: new SalesApiInfo({
      path: '/data/agent-report/ka-top-ten',
      type: 'get',
      author: '杜伟',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-搜索产品名
    productReportSearch: new SalesApiInfo({
      path: '/data/product-report/search',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-精准查询(某一个产品)-趋势分析
    productReportPrecisionLine: new SalesApiInfo({
      path: '/data/product-report/precision-line',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-精准查询(某一个产品)-趋势分析
    // productReportPrecisionPie: new SalesApiInfo({
    //   path: '/data/product-report/precision-pie',
    //   type: 'get',
    //   author: '郭留永',
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    //   }
    // }),

    // 产品报表-精准查询(某一个产品)-趋势分析
    productReportPrecisionPie: new SalesApiInfo({
      path: '/data/product-report/precision-proportion',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-详细数据
    productReportList: new SalesApiInfo({
      path: '/data/product-report/list',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 聚合报表-详细数据
    agentReportList: new SalesApiInfo({
      path: '/data/agent-report/list',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 直客报表
    dcReportList: new SalesApiInfo({
      path: '/data/agent-report/direct-list',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    
    // 聚合报表-详细数据
    kaReportList: new SalesApiInfo({
      path: '/data/agent-report/ka-list',
      type: 'get',
      author: '杜伟',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
    // 聚合报表-详细数据
    seriesReportList: new SalesApiInfo({
      path: '/data/series-report/list',
      type: 'get',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-详细数据-下载
    productReportDownload: new SalesApiInfo({
      path: '/data/product-report/download',
      type: 'post',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 聚合报表-详细数据-下载
    agentReportDownload: new SalesApiInfo({
      path: '/data/agent-report/download',
      type: 'post',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品系报表-详细数据-下载
    seriesReportDownload: new SalesApiInfo({
      path: '/data/series-report/download',
      type: 'post',
      author: '王晓阳',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-精准查询(某一个产品)
    productReportPrecisionList: new SalesApiInfo({
      path: '/data/product-report/precision-list',
      type: 'get',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 产品报表-精准查询(某一个产品)-下载
    productReportPrecisionDownload: new SalesApiInfo({
      path: '/data/product-report/precision-download',
      type: 'post',
      author: '郭留永',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 直客用户列表接口
    directGetSalesList: new SalesApiInfo({
      path: '/data/direct/get-sales-list',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 我的业绩
    directPerformance: new SalesApiInfo({
      path: '/data/direct/performance',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 三个图表
    directActiveAndNew: new SalesApiInfo({
      path: '/data/direct/active-and-new',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 漏斗
    directFunnel: new SalesApiInfo({
      path: '/data/direct/funnel',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 业绩风云榜+完成率风云榜接口
    directRanking: new SalesApiInfo({
      path: '/data/direct/ranking',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 趋势分析汇总接口
    directChart: new SalesApiInfo({
      path: '/data/direct/chart',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 趋势分析TOP10接口
    directChartTop: new SalesApiInfo({
      path: '/data/direct/chart-top',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 占比分析饼图接口
    directPie: new SalesApiInfo({
      path: '/data/direct/pie',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 列表接口
    directList: new SalesApiInfo({
      path: '/data/direct/list',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 列表下载接口
    directDownloadList: new SalesApiInfo({
      path: 'data/direct/download-list',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 列表下载接口
    volatilityAllMediaDashboard: new SalesApiInfo({
      path: '/data/volatility/all-media-dashboard',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 列表下载接口
    volatilityTopSummary: new SalesApiInfo({
      path: '/data/volatility/top-summary',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    // 列表下载接口
    volatilityTopAgentDetail: new SalesApiInfo({
      path: '/data/volatility/top-agent-detail',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    volatilityTopProductDetail: new SalesApiInfo({
      path: '/data/volatility/top-product-detail',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    volatilitytopSummaryRate: new SalesApiInfo({
      path: '/data/volatility/top-summary-rate',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),

    volatilityGetByType: new SalesApiInfo({
      path: '/data/volatility/get-by-type',
      type: 'post',
      author: '易怀源',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }),
  },
  download: {
    // 提交下载请求
    requestAdd: new SalesApiInfo({
      path: '/download/request/add',
      type: 'post',
      author: '徐从斌',
    }),

    // 下载列表
    requestList: new SalesApiInfo({
      path: '/download/request/list',
      type: 'get',
      author: '徐从斌',
    }),

    // 获取下载文件
    requestFetch: new SalesApiInfo({
      path: '/download/request/fetch',
      type: 'post',
      author: '徐从斌',
    }),
  },
  warningMonitor: {
    // 列表
    list: new SalesApiInfo({
      path: '/monitor/list',
      type: 'get',
      author: '徐从斌',
    }),
    // 开关
    switch: new SalesApiInfo({
      path: '/monitor/open',
      type: 'get',
      author: '徐从斌',
    }),
    // 删除
    delete: new SalesApiInfo({
      path: '/monitor/delete',
      type: 'get',
      author: '徐从斌',
    }),
    // 搜索对象
    searchObj: new SalesApiInfo({
      path: '/monitor/object/search',
      type: 'get',
      author: '徐从斌',
    }),
    // 详情
    detail: new SalesApiInfo({
      path: '/monitor/detail',
      type: 'get',
      author: '徐从斌',
    }),
    // 添加
    add: new SalesApiInfo({
      path: '/monitor/add',
      type: 'post',
      author: '徐从斌',
    }),
    // 编辑
    edit: new SalesApiInfo({
      path: '/monitor/update',
      type: 'post',
      author: '徐从斌',
    }),
  },
};
